import { useState, useEffect } from "react";

import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import Divider from "@mui/material/Divider";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for CashierNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/CashierNavbar/styles";


// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import MDTypography from "components/MDTypography";
import logoPic from "assets/images/mobitoken.png"

import userPic from "assets/images/tmOLqafAR9yoKwHN8g5gCxlbgSE60nDS.png"

function CashierNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <MDBox display="flex" justifyContent="space-evenly" alignItems="center">
        <img src={userPic} width={"50rem"} height={"50rem"}/>
        <MDBox display="block">
        <MDTypography display="block" variant="button" fontWeight="medium" color="dark">
          AbuStefan
        </MDTypography>
        <MDTypography display="block" variant="button" fontWeight="regular" color="dark">
          Cashier
        </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <Link to={"/authentication/sign-in"}>
        <NotificationItem icon={<Icon>logout</Icon>} title="Logout"  />
      </Link>

    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:"100%"}}>
        <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:"100%"}} px={3} ml={18} >
          <MDAvatar src={logoPic} name={"logo"} size="md" 
          sx={({ borders: { borderWidth }, palette: { white } }) => ({
          border: `${borderWidth[2]} solid ${white.main}`,
          mr: 1,
        })} />
          <MDTypography variant="h3">Sundook Cashier</MDTypography>
        </MDBox>
        <MDBox color={light ? "white" : "inherit"} display="flex" sx={{justifyContent:"flex-end"}}>
        <IconButton sx={navbarIconButton} size="small" disableRipple onClick={handleOpenMenu}>
          <Icon sx={iconsStyle}>account_circle</Icon>
        </IconButton>
        <IconButton
          size="small"
          disableRipple
          color="inherit"
          sx={navbarMobileMenu}
          onClick={handleMiniSidenav}
        >
          <Icon sx={iconsStyle} fontSize="medium">
            {miniSidenav ? "menu_open" : "menu"}
          </Icon>
        </IconButton>
        <IconButton
          size="small"
          disableRipple
          color="inherit"
          sx={navbarIconButton}
          onClick={handleConfiguratorOpen}
        >
          <Icon sx={iconsStyle}>settings</Icon>
        </IconButton>
        <IconButton
          size="small"
          disableRipple
          color="inherit"
          sx={navbarIconButton}
          aria-controls="notification-menu"
          aria-haspopup="true"
          variant="contained"
        >
          <Icon sx={iconsStyle}>notifications</Icon>
        </IconButton>
        {renderMenu()}
      </MDBox>
      </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of CashierNavbar
CashierNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the CashierNavbar
CashierNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default CashierNavbar;
